<template>
  <div class="order-address"  v-loading="loading">
    <el-row class="form-item">
      <!-- 标题 -->
      <el-col :span="3">
        <p><span class="required-text">*</span>收货地址</p>
        <!-- <p class="new-adress" @click="toAdd">新建地址</p> -->
      </el-col>

      <!-- 搜索条件 -->
      <el-col :span="21">
        <el-col :span="7">
          <el-input
            v-model="queryParam.contactPerson"
            style="width:90%;"
            placeholder="请输入联系人"
            clearable
            class="panel-input"
          />
        </el-col>
        <el-col :span="7">
          <el-input
            v-model="queryParam.contactMobile"
            style="width:90%;"
            placeholder="请输入联系手机"
            clearable
            class="panel-input"
          />
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="queryAddress">搜索</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button>
          <el-button type="primary" @click="toAdd">新建地址</el-button>
        </el-col>
      </el-col>

      <!-- 卡片部分 -->
      <el-col :span="21" class="card-wp">
        <el-col
          :span="7"
          v-for="(item, index) in addressList"
          :key="index"
          @click.native="checkAddress(item)"
          class="card"
        >
          <i
            class="choose-card"
            :class="item.checked === true ? 'el-icon-circle-check' : ''"
          ></i>
          <el-card
            shadow="always"
            :body-style="
              item.checked === true ? { background: 'rgb(235, 244, 255)' } : {}
            "
          >
            <div class="text">
              {{ item.contactPerson }} {{ item.contactMobile }}
            </div>
            <div class="text">
              {{ item.provinceName }} {{ item.cityName }} {{ item.countyName }}
            </div>
            <div class="text">{{ item.detailAddress }}</div>
            <div class="setAddress">
              <span class="info" @click="setDefault(item)">{{
                item.isDefault ? "默认地址" : "设为默认"
              }}</span>
              <span class="info" @click="updateAddress(item)">修改</span>
              <span class="info" @click="removeAddress(item)">删除</span>
            </div>
          </el-card>
        </el-col>

        <!-- 新建地址 -->
        <!-- <el-col :span="7" class="new-card card">
          <el-card shadow="always" @click.native="toAdd">
            <div class="text">+ 新建地址</div>
          </el-card>
        </el-col> -->
      </el-col>

      <!-- 分页部分 -->
      <el-col :span="24" v-if="addressList && addressList.length">
        <div class="page-row">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="queryParam.page"
            :page-size="queryParam.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-col>
      <el-col :span="24" v-else style="text-align:center;color:#aaa;">
        <p>暂无数据</p>
      </el-col>
    </el-row>
    <AddressForm ref="address-form" @success="getAddressList" />
  </div>
</template>

<script>
import userApi from '@/api/user'
import AddressForm from '../../user/components/address-form'
export default {
  name: 'orderAddress',
  components: {
    AddressForm
  },
  data () {
    return {
      loading: false,
      addressList: [],
      total: null,
      queryParam: {
        page: 1,
        pageSize: 6,
        contactPerson: '',
        contactMobile: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getAddressList()
    },
    // 获取地址
    getAddressList () {
      this.loading = true
      this.$emit('setAddress', '')
      userApi.getAddressList(this.queryParam).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.addressList = res.data.resultData.addressList
          this.total = res.data.resultData.pageInfo.totalCounts
          if (this.addressList) {
            this.addressList.forEach(item => {
              this.$set(item, 'checked', false)
            })
          }
        }
      })
    },
    // 查找地址
    queryAddress () {
      this.queryParam.page = 1
      this.getAddressList()
    },

    handleReset () {
      this.queryParam = this.$options.data().queryParam
      this.getAddressList()
    },
    // 修改地址
    updateAddress (item) {
      const addressForm = Object.assign({ action: 'update' }, item)
      this.$refs['address-form'].show(addressForm)
    },
    // 删除地址
    removeAddress (item) {
      this.$confirm('是否删除收货地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userApi
            .removeAddress(item)
            .then(response => {
              if (response.data.resultCode === '0') {
                this.getAddressList()
                this.$message.success('收货地址删除成功')
              }
            })
            .catch(() => {
              this.$message.error('收货地址删除失败')
            })
        })
        .catch(() => {})
    },
    // 修改默认地址
    setDefault (address) {
      if (address.isDefault) {
        return
      }
      this.$confirm('是否设置为默认地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          address.isDefault = 1
          userApi.updateAddress(address).then(response => {
            if (response.data.resultCode === '0') {
              this.getAddressList()
              this.$message.success('设置默认地址成功')
            }
          })
        })
        .catch(() => {})
    },
    // 选择地址
    checkAddress (checkedItem) {
      if (this.addressList) {
        this.addressList.forEach(item => {
          item.checked = false
        })
      }
      checkedItem.checked = true
      let value = {
        clientAddressId: checkedItem.addressId
      }
      this.$emit('setAddress', value)
    },
    // 新建地址
    toAdd () {
      const addressForm = { action: 'create' }
      this.$refs['address-form'].show(addressForm)
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getAddressList()
    }
  }
}
</script>

<style lang="scss" scoped>
.order-address {
  .form-item {
    padding: 25px;
    .new-adress {
      font-size: 12px;
      color: rgb(32, 160, 255);
      padding-left: 10px;
      cursor: pointer;
      width: 50px;
    }

    .el-card.is-always-shadow {
      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
    }
    .card-wp {
      margin-top: 30px;
      .new-card {
        .text {
          font-weight: 600;
          text-align: center;
          padding: 35px 0 !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .card {
        margin: 10px 10px 10px 0;
        cursor: pointer;
        position: relative;

        .choose-card {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 15px;
          height: 15px;
          display: block;
          border-radius: 50%;
          border: 1px solid #ccc;
        }
        .el-icon-circle-check {
          border: none;
          font-size: 20px;
          color: rgb(200, 16, 45);
          font-weight: 700;
          margin-right: 5px;
        }

        .el-card__body {
          padding: 12px !important;
        }

        .text {
          padding: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          white-space: nowrap;
        }
      }

      .setAddress {
        font-size: 12px;
        color: rgb(32, 160, 255);
        text-align: right;

        .info {
          margin-left: 10px;
        }
      }
    }
    .page-row {
      text-align: center;
      margin-top: 30px;
    }
  }
}
</style>
